import { parse as parseQueryString } from 'querystring';
import cookie from 'cookie';
import { SCREEN_TYPES } from 'constants/media-queries';

const UPDATE_REQUEST = 'classpass/request/UPDATE_REQUEST';

export const setRequestDetailsOnServer = req => ({ type: UPDATE_REQUEST, req });
export const setRequestDetailsOnClient = () => ({ type: UPDATE_REQUEST });

export const selectQuery = state => state.request.query;
export const selectDeviceType = state => state.request.deviceType;

export const getInitialState = () => ({
  protocol: '',
  query: {},
  path: '',
  hostname: '',
  cookies: {},
  userAgent: '',
});

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    case UPDATE_REQUEST: {
      if (__SERVER__) {
        const MobileDetect = require('mobile-detect');

        const { req } = action;
        if (req) {
          const device = new MobileDetect(req.get('user-agent'));
          let deviceType;

          if (device.phone()) {
            deviceType = SCREEN_TYPES.phone;
          } else if (device.tablet()) {
            deviceType = SCREEN_TYPES.tablet;
          } else if (!device.mobile()) {
            deviceType = SCREEN_TYPES.desktop;
          } else {
            deviceType = SCREEN_TYPES.unknown;
          }

          const cookies = {
            ...cookie.parse(req.get('cookie') || ''),
            ...req.cookies,
          };

          return {
            protocol: req.protocol,
            query: req.query,
            path: req.path,
            hostname: req.hostname,
            cookies,
            visitorId: cookies.cpVisitorId,
            deviceType,
            userAgent: req.get('user-agent'),
            baseUrl: `${req.protocol}://${req.hostname}/`,
            currentFullUrl: `${req.protocol}://${req.hostname}${req.originalUrl}`,
          };
        }
      }

      const cookies = cookie.parse(document.cookie || '');

      return {
        ...state,
        protocol: window.location.protocol.replace(/:$/, ''),
        query: window.location.search ? parseQueryString(window.location.search.substr(1)) : {},
        path: window.location.pathname,
        hostname: window.location.host.replace(/:\d+$/, ''),
        cookies,
        userAgent: navigator.userAgent,
        baseUrl: `${window.location.protocol}//${window.location.host.replace(/:\d+$/, '')}/`,
        currentFullUrl: window.location.href,
        visitorId: cookies.cpVisitorId,
      };
    }
    default:
      return state;
  }
}
